import React, { Component } from 'react';
import { connect } from 'react-redux';
import { logout as logoutFun } from '../../services';

interface IframeContentProps {
    /**
     * 退出
     */
    logout: () => void;
    /**
     * 页面链接
     */
    href: string;
    /**
     * 域名地址
     */
    url?: string;
}

class IframeContent extends Component<IframeContentProps> {
  onLoad() {
    const iframe: any = this.refs.iframe;
    if (ENV.API_ROOT && new URL(ENV.API_ROOT).host !== window.location.host) {
      return;
    }
    setTimeout(function() {
      if (!iframe.contentWindow) {
        return;
      }
      iframe.setAttribute(
        'height',
        iframe.contentWindow.document.documentElement.scrollHeight + 30
      );
    }, 500);
    if (iframe.contentWindow.location.href.indexOf('timeOutRedirect') !== -1) {
      logoutFun();
    }
  }
  render() {
    const { href } = this.props;
    return (
      <iframe
        src={ENV.API_ROOT + href}
        frameBorder="0"
        width="100%"
        height="600"
        ref="iframe"
        onLoad={this.onLoad.bind(this)}
        title={href}
      />
    );
  }
}

function mapDispatchToProps(dispatch: any, props: any) {
  return {
    // logout() {
    //   dispatch(actions.logoutAction());
    // },
  };
}

export const Iframe = connect(null, mapDispatchToProps)(IframeContent);
